import { Drawer } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";
import { Except } from "type-fest";
import { Merchandise } from "types";
import { InventoryTable } from "@/components/Product/MerchandiseInventory/InventoryTable";
import { useInventoryLots } from "@/hooks/resources/useInventoryLots";

interface ManageInventoryModalProps {
    isOpen: boolean;
    merchandise: Merchandise;
    onClose: () => void;
}

export const ManageInventoryModal = ({ isOpen, merchandise, onClose }: ManageInventoryModalProps) => {
    return (
        <Drawer
            size="2xl"
            isOpen={isOpen}
            content={isOpen ? <DrawerContent merchandise={merchandise} onClose={onClose} /> : null}
            classNames={{ dialog: "z-20", content: "mt-0" }}
            onClose={onClose}
        />
    );
};

const DrawerContent = ({ merchandise, onClose }: Except<ManageInventoryModalProps, "isOpen">) => {
    const { data: lots, isLoading } = useInventoryLots([
        { id: merchandise.id, name: merchandise.name, photoId: merchandise.photo?.id },
    ]);

    return (
        <div className="flex h-full flex-col">
            <div className="border-b border-gray-lighter">
                <h3>Manage Inventory</h3>
            </div>
            <div className="flex-1 overflow-hidden">
                <InventoryTable showLedgerAction lots={lots} isLoading={isLoading} />
            </div>
            <div className="border-t border-gray-lighter py-2">
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </div>
        </div>
    );
};
